<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row class="mx-1">
      <b-col lg="12">
        <b-card
          title="Prévisualisation des relevés de compte"
          bg-variant="secondary"
          class
        >
          <b-button class="mb-3" @click="confirm" variant="success"
            >Confirmer les relevés</b-button
          >
          <b-row>
            <b-col lg="6">
              <b-card
                class="mb-3"
                header-tag="h6"
                header-text-variant="light"
                bg-variant="secondary"
                header="Par virement"
              >
                <object
                  style="width: 100%; height: 1000px"
                  :data="pdf_virement"
                  type="application/pdf"
                >
                  <embed :src="pdf_virement" type="application/pdf" />
                </object>
              </b-card>
            </b-col>
            <b-col lg="6">
              <b-card
                class="mb-3"
                header-tag="h6"
                header-text-variant="light"
                bg-variant="secondary"
                header="Par chèque"
              >
                <object
                  style="width: 100%; height: 1000px"
                  :data="pdf_check"
                  type="application/pdf"
                >
                  <embed :src="pdf_check" type="application/pdf" />
                </object>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="Création des relevés de compte"
      id="process_account"
      title-class="text-center"
      hide-footer
      centered
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-progress
        height="2rem"
        variant="success"
        :value="percentage"
        :max="100"
        show-progress
        animated
      ></b-progress>
    </b-modal>
  </div>
</template>

<script>
import account_statements from "@/services/account-statements.js";
export default {
  props: {
    creditors: {
      type: Array,
    },
  },
  data: () => {
    return {
      offset: null,
      percentage: null,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Gestion des relevés de compte",
          to: { name: "manageAccountStatements" },
        },
        {
          text: "Prévisualisation",
          active: true,
        },
      ],
    };
  },
  computed: {
    pdf_virement() {
      return (
        this.$store.getters.url +
        "/account-statements/transfer?ids=" +
        JSON.stringify(this.creditors) +
        "&token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
    pdf_check() {
      return (
        this.$store.getters.url +
        "/account-statements/check?ids=" +
        JSON.stringify(this.creditors) +
        "&token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
  },
  methods: {
    confirm() {
      this.percentage = 0;
      this.$bvModal.show("process_account");

      account_statements.confirm(this.creditors).then((response) => {
        this.offset = response.data.offset;
        this.percentage = response.data.percentage;
        if (response.data.continue) {
          this.continue();
        } else {
          this.finish();
        }
      });
    },
    continue() {
      account_statements
        .confirm(this.creditors, this.offset)
        .then((response) => {
          this.offset = response.data.offset;
          this.percentage = response.data.percentage;
          if (response.data.continue) {
            this.continue();
          } else {
            this.finish();
          }
        });
    },
    finish() {
      this.$bvModal.hide("process_account");
      this.$store.commit("updateAccountStatements", []);
      this.$bvModal
        .msgBoxOk("Action terminée", {
          centered: true,
        })
        .then(() => {
          this.$router.push({ name: "account-statements" });
        })
        .catch(() => {
          this.$router.push({ name: "account-statements" });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>